import commonRoutes, { getTransitionPath, UrlParamKey } from './commonRoutes'

export const workflowRoutes = {
  WORKFLOWS: commonRoutes.FORMS,
}

export const WorkflowUrlParamKey = UrlParamKey.Form

export function getWorkflowIdFromSearch(
  searchParams: URLSearchParams = new URLSearchParams(location.search),
): string | null {
  return searchParams.get(WorkflowUrlParamKey)
}

export function getWorkflowDirectLink(
  projectCode: string,
  workflowId: string,
): string {
  return `${window.location.origin}${getTransitionPath(
    workflowRoutes.WORKFLOWS,
    projectCode,
  )}?${WorkflowUrlParamKey}=${workflowId}`
}
